// feature/carpeta-lawyer-visibility — P2.2 change 5. Minimal status
// pill rendered to viewers WITHOUT carpeta-upload capability (i.e.,
// abogados looking at a case detail). Replaces the full
// CarpetaDocumentsPanel + the P2.1 hint — lawyers don't manage these
// documents, so the per-slot detail and upload buttons would be
// noise. The badge tells them at a glance whether the carpeta team
// has finished assembling the case's billing folder.
//
// States (from /api/cases/:id/carpeta-documents completeness):
//   • required > 0 && present == required → "completa" (mint)
//   • 0 < present < required               → "en preparación (N/M)" (warning amber)
//   • present == 0                         → "pendiente" (muted)
//
// Styling matches the existing badge pattern (Pills.js convention).
import React, { useEffect, useState } from "react";
import { carpetas } from "../api/endpoints";

export default function CarpetaStatusBadge({ caseId }) {
  const [comp, setComp] = useState(null);

  useEffect(() => {
    if (!caseId) return;
    let cancelled = false;
    carpetas.getCarpetaDocuments(caseId)
      .then((r) => { if (!cancelled) setComp(r.data?.completeness || null); })
      .catch(() => { if (!cancelled) setComp(null); });
    return () => { cancelled = true; };
  }, [caseId]);

  if (!comp) return null;

  const { required = 0, present = 0 } = comp;
  let cls = "muted";
  let label = "Carpeta de cobro: pendiente";
  if (required > 0 && present === required) {
    cls = "mint";
    label = "Carpeta de cobro: completa";
  } else if (present > 0 && present < required) {
    cls = "warning";
    label = `Carpeta de cobro: en preparación (${present}/${required})`;
  }
  return <span className={"badge " + cls}>{label}</span>;
}
